module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.category) ? _c('div', [_c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v(_vm._s(_vm.category.name))]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Utforsk varesortimentet nedenfor og plasser bestillingen via handlekurven.")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "clearfix mxn2"
  }, _vm._l((_vm.category.products), function(product) {
    return _c('div', {
      staticClass: "sm-col sm-col-12 md-col-6 lg-col-4 xl-col-3 px2 mb3"
    }, [_c('div', {
      staticClass: "card rounded sh1"
    }, [_c('div', {
      staticClass: "p2 bold pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(product.id)
        }
      }
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('div', [_c('img', {
      staticClass: "pointer",
      attrs: {
        "src": _vm.getPicture(product),
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(product.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "p2 product-description"
    }, [_vm._v(_vm._s(product.short_description))]), _vm._v(" "), _c('div', {
      staticClass: "border-bottom border-light-grey"
    }), _vm._v(" "), _c('div', {
      staticClass: "p2"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary right m0",
      nativeOn: {
        "click": function($event) {
          _vm.viewProduct(product.id)
        }
      }
    }, [_vm._v("Kjøp")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "text-grey fz12"
    }, [_vm._v("Fra")]), _vm._v(" "), _c('div', {
      staticClass: "bold text-grey fz18"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(product.from_price)) + ",-")])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)])])
  }))])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f587cd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/shop/ProductCategory.vue
// module id = 636
// module chunks = 1